module.exports = __webpack_public_path__ + "media/images/tout_seul_dans_le_bois-627e778423532aaf1ca0bb51a93e86f2.png";